module.exports = __webpack_public_path__ + "static/img/03b.62c5f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/brand/03b.png
// module id = 1p0J
// module chunks = 3